import { render } from "./FeedbackNegative.vue?vue&type=template&id=5bd14fb6&scoped=true"
import script from "./FeedbackNegative.vue?vue&type=script&lang=js"
export * from "./FeedbackNegative.vue?vue&type=script&lang=js"

import "./FeedbackNegative.vue?vue&type=style&index=0&id=5bd14fb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd14fb6"]])

export default __exports__